import React from 'react';

import Text from 'components/shared/Typography/Text';

import { useCollapseDays } from '../../functions';
import s from './index.module.css';
import { IHiddenDaysProps } from './types';

export const HiddenDays = ({ day, showDay, onToggle }: IHiddenDaysProps) => {
  const { isCollapsed } = useCollapseDays();

  if (!isCollapsed) return null;

  return (
    <div onClick={onToggle}>
      <Text accent size="medium" className={s.hiddenDaysWrapper}>
        <span className={s.events}> {showDay ? 'Hide Events' : 'Show Events'}</span>{' '}
        <span className={s.hiddenEventsCount}>({day.tripEvents.length})</span>
      </Text>
    </div>
  );
};
